import * as tslib_1 from "tslib";
import getCategoryActionDecisionProperties from './getCategoryActionDecisionProperties';
import { getCategoryMenuProps, getMasterCategoryList } from 'owa-categories';
import { resetFocus } from 'owa-mail-focus-manager';
import { listViewStore } from 'owa-mail-list-store';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { lazyAddCategoriesFromTable, lazyRemoveCategoriesFromTable, lazyClearCategoriesFromTable, } from 'owa-mail-triage-action';
import { CATEGORY_MENU_WIDTH } from './constants';
export function getCategoryMenuPropertiesForCommandBar(tableView, actionSource) {
    return getCategoriesMenuProperties(tableView, true /* showSearchBox */, true /* showManageCategories */, function () { return resetFocus(); }, // always reset focus to dismiss the menu from commanding bar
    actionSource, 'CommandBar');
}
/**
 * Gets the category menu items for context menu
 * @param tableViewId the tableView id
 * @param dismissMenu the callback to be called to dismiss of menu
 * @param actionSource the actionSource
 * @return returns the contextual menu items
 */
export function getCategoryMenuPropertiesForContextMenu(tableViewId, dismissMenu, actionSource, shouldShowSearch) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    return getCategoriesMenuProperties(tableView, shouldShowSearch /* showSearchBox */, true /* showManageCategories */, dismissMenu, // Callback to dismiss the right click context menu
    actionSource, 'ContextLV', 11 /* rightTopEdge */);
}
/**
 * Gets the category menu items
 * @param tableView the tableView
 * @param showSearchBox flag indicating whether to show search box or not
 * @param showManageCategoriesBox flag indicating whether to the manage categories option or not
 * @param dismissMenu callback to be called to dismiss the category context menu
 * @param actionSource the actionSource
 * @param categoryActionSource the category action source
 * @param directionalHint determines which direction the callout appears, defaults to bottomLeftEdge
 * @return returns the contextual menu items
 */
function getCategoriesMenuProperties(tableView, showSearchBox, showManageCategories, dismissMenu, actionSource, categoryActionSource, directionalHint) {
    var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
    var _a = getCategoryActionDecisionProperties(tableView, selectedRowKeys), commonRowCategories = _a.commonRowCategories, rowsHaveCategories = _a.rowsHaveCategories;
    var categoryMenuProps = getCategoryMenuProps({
        actionSource: categoryActionSource,
        categoryList: getMasterCategoryList(),
        categoriesToCheck: commonRowCategories,
        dismissMenu: dismissMenu,
        shouldShowSearchBox: showSearchBox,
        shouldShowManageCategories: showManageCategories,
        shouldShowClearCategories: rowsHaveCategories,
        onAfterCreateNewCategory: function (category, createNewCategoryPromise) {
            // When a new category is created, we should apply it optimistically to the selected items
            lazyAddCategoriesFromTable.importAndExecute(selectedRowKeys, tableView, [category], actionSource, createNewCategoryPromise);
        },
        onCheckedCategoryClicked: function (category) {
            // When a checked category is clicked its a remove action
            lazyRemoveCategoriesFromTable.importAndExecute(selectedRowKeys, tableView, [category], actionSource);
        },
        onUncheckedCategoryClicked: function (category) {
            // When an unchecked category is clicked its an add action
            lazyAddCategoriesFromTable.importAndExecute(selectedRowKeys, tableView, [category], actionSource);
        },
        onManageCategoryClicked: onManageCategoryClicked,
        onClearCategoriesClicked: function () {
            lazyClearCategoriesFromTable.importAndExecute(selectedRowKeys, tableView, actionSource);
        },
        directionalHint: directionalHint,
        width: CATEGORY_MENU_WIDTH,
    });
    return categoryMenuProps;
}
/**
 * Custom callback function when manage category is clicked
 */
function onManageCategoryClicked() {
    // Navigate to options/categories
    lazyMountAndShowFullOptions.importAndExecute('general', 'categories');
}
//# sourceMappingURL=getCategoryMenuProperties.js.map